<div class="wrapper">
  <div class="headerWrapper">
    <h2>Производители</h2>
    <mat-form-field appearance="standard">
      <mat-label>Фильтр</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Фильтр" #input />
    </mat-form-field>
    <button mat-mini-fab color="primary" (click)="add()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="tableWrapper">
    <table mat-table [dataSource]="filteredList">
      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td
          mat-cell
          *matCellDef="let manufacturer"
          class="select"
          [routerLink]="['/manufacturer/profile', manufacturer.id]"
        >
          {{ manufacturer.id }}
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Название</th>
        <td
          mat-cell
          *matCellDef="let manufacturer"
          class="select"
          [routerLink]="['/model/list', manufacturer.id]"
        >
          {{ manufacturer.description }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="5">Не могу ничего найти :(</td>
      </tr>
    </table>
  </div>
</div>
